<template>
    <section class="m-print-part">
        <div class="m-industry-box3">
            <span class="u-industry-btn2" @click="doPrintVue">打印</span>
        </div>
        <div id="printOrder">
            <h2 class="u-print-title1">新浪“金麒麟”最佳分析师评选</h2>
            <h3 class="u-print-des1">{{qsName}}参选报名情况如下：</h3>
            <ul class="m-print-blk">
                <li
                    v-for="(item , index) in ListDatas"
                    :key="item.id"
                    class="u-print-item"
                >{{index+1}}.{{item.hy_name}}:{{item.chair_name}}（首席）</li>
            </ul>
            <div class="m-print-signature">券商研究所签名：_____________________</div>
            <div class="m-print-time">
                时间：
                <span class="u-print-tag1">年</span>
                <span class="u-print-tag2">月</span>
            </div>
            <div class="m-print-explain">
                <div class="u-explain-name">说明：</div>
                <div class="u-explain-box">
                    <p class="u-print-des2">（1）券商研究所参选报名新浪“金麒麟”最佳分析师评选活动须保证团队报名信息真实有效。</p>
                    <p class="u-print-des2">（2）新浪将以最后报名截止日期为准对研究团队进行参评，若有异议请及时反馈联系。</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "Print",
    props: {
        msg: String
    },
    data() {
        return {
            qsName: "",
            ListDatas: []
        };
    },
    beforeCreate() {
        document
            .querySelector("body")
            .setAttribute("style", "background:#fff;");
    },
    beforeDestroy() {
        document.querySelector("body").removeAttribute("style");
    },
    created() {
        this.detection();
        this.getLists();
    },
    methods: {
        getLists() {
            var _this = this;
            let param = {
                url:
                    "//support.finance.sina.com.cn/service/api/openapi.php/JinQiService.getQsInfo",
                // ?acode=ajzq_020235f9c2af&atype=qs&hy_id=1
                acode: sessionStorage.getItem("acode"),
                atype: "qs"
            };
            // 发送 POST 请求
            this.$jsonp(param.url, {
                acode: param.acode,
                atype: param.atype
            })
                .then(function(response) {
                    // console.log(response);
                    if (response.result.status.code == 0) {
                        let datas = response.result.data;
                        _this.ListDatas = datas.hy;
                        _this.qsName = datas.qs.name;
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        doPrintVue() {
            // var newstr = document.getElementById("printOrder").innerHTML;
            // document.body.innerHTML = newstr;
            window.print();
            // 重新加载页面，以刷新数据
            // window.location.reload();
        },
        detection() {
            // alert(1); 
            let name = sessionStorage.getItem("name");
            // alert(name);
            if (!name) {
                this.$router.push({ path: "/" });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.m-print-part {
    position: relative;
    margin: 0 auto;
    width: 600px;
    .u-print-title1 {
        margin: 30px auto;
        line-height: 20px;
        font-size: 20px;
        color: #000000;
        text-align: center;
    }
    .u-print-des1 {
        margin-bottom: 20px;
        line-height: 12px;
        font-size: 12px;
        color: #000000;
    }
    .m-print-blk {
        &:after {
            content: "";
            display: block;
            height: 0;
            width: 0;
            overflow: hidden;
            clear: both;
        }

        .u-print-item {
            float: left;
            width: 50%;
            line-height: 26px;
            font-size: 12px;
            color: #000000;
        }
    }
    .m-print-signature {
        margin-top: 200px;
        text-align: right;
    }
    .m-print-time {
        margin-top: 40px;
        font-size: 12px;
        color: #000000;
        text-align: right;
        line-height: 12px;
        .u-print-tag1 {
            padding-left: 80px;
        }
        .u-print-tag2 {
            padding-left: 51px;
        }
    }
    .m-print-explain {
        margin-top: 80px;
        .u-explain-name {
            float: left;
            width: 36px;
            font-size: 12px;
            color: #000000;
        }
        .u-explain-box {
            float: left;
            width: 490px;
        }
        .u-print-des2 {
            font-size: 12px;
            color: #000000;
            line-height: 26px;
        }
    }
    .m-industry-box3 {
        position: absolute;
        top: 40px;
        left: -240px;
    }
}
</style>
